const organizationConfig = {
  nextias: {
    orgId: '2410f924-6cc4-4e88-b490-ffd3bbc40d03',
    organizationName: 'nextias',
    logo: 'https://cdnstatic.nextias.com/resources/logos/Clip%20path%20group-1741069343449.svg',
    websiteBaseUrl: process.env.REACT_APP_NEXTIAS_HOST_URL,
    // Where a student is sent when an order cannot be processed on the page —
    // see the draft fallback in pages/order-details.
    supportUrl: `${process.env.REACT_APP_NEXTIAS_HOST_URL}/contact-us`,
    thankYou: {
      successURL: `${process.env.REACT_APP_NEXTIAS_HOST_URL}/payment-success`,
      failureURL: `${process.env.REACT_APP_NEXTIAS_HOST_URL}/payment-failure`,
    },
    redirect: {
      successURL: `${process.env.REACT_APP_NEXTIAS_HOST_URL}/prep/my-course`,
      failureURL: `${process.env.REACT_APP_NEXTIAS_HOST_URL}/prep/home`,
    },
  },
  meniit: {
    orgId: 'c2a3acad-54ba-437f-85a1-d0d850cec900',
    organizationName: 'meniit',
    logo: 'https://cdnstatic.meniit.com/resources/logos/MENIIT-1732862852503.svg',
    websiteBaseUrl: process.env.REACT_APP_MADEEASY_HOST_URL,
    // Where a student is sent when an order cannot be processed on the page —
    // see the draft fallback in pages/order-details.
    supportUrl: `${process.env.REACT_APP_MADEEASY_HOST_URL}/contact-us`,
    thankYou: {
      successURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/payment-success`,
      failureURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/payment-failure`,
    },
    redirect: {
      successURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/prep/my-course`,
      failureURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/prep/home`,
    },
  },
  madeeasy: {
    orgId: '9a523aa7-dc66-410a-98bb-8cd66e875f35',
    organizationName: 'madeeasy',
    logo: 'https://cdnstatic.nextias.com//Group-1741069899954.svg',
    websiteBaseUrl: process.env.REACT_APP_MADEEASY_HOST_URL,
    // Where a student is sent when an order cannot be processed on the page —
    // see the draft fallback in pages/order-details.
    supportUrl: `${process.env.REACT_APP_MADEEASY_HOST_URL}/contact-us`,
    thankYou: {
      successURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/payment-success`,
      failureURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/payment-failure`,
    },
    redirect: {
      successURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/prep/my-course`,
      failureURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/prep/home`,
    },
  },
  // REACT_APP_SKILLDOME_HOST_URL is deliberately set to the NEXT IAS host in
  // every .env: Skill Dome has its own logo but not its own prep site yet, so
  // the thank-you and post-payment redirects land on NEXT IAS's. It is a
  // variable of its own rather than a reference to the NEXTIAS one so that
  // giving Skill Dome its own site later is an env change, not a code change.
  skilldome: {
    orgId: '21e2d222-e432-496b-aaa2-f5cccd72f6ca',
    organizationName: 'skilldome',
    logo: 'https://skilldome.madeeasy.in/resources/images/icons/skill-dome-logo.webp',
    websiteBaseUrl: process.env.REACT_APP_SKILLDOME_HOST_URL,
    // Where a student is sent when an order cannot be processed on the page —
    // see the draft fallback in pages/order-details.
    supportUrl: `${process.env.REACT_APP_SKILLDOME_HOST_URL}/contact-us`,
    thankYou: {
      successURL: `${process.env.REACT_APP_SKILLDOME_HOST_URL}/payment-success`,
      failureURL: `${process.env.REACT_APP_SKILLDOME_HOST_URL}/payment-failure`,
    },
    redirect: {
      successURL: `${process.env.REACT_APP_SKILLDOME_HOST_URL}/prep/my-course`,
      failureURL: `${process.env.REACT_APP_SKILLDOME_HOST_URL}/prep/home`,
    },
  },
  madeeasyprime: {
    orgId: '9a523aa7-dc66-410a-98bb-8cd66e875f35',
    organizationName: 'madeeasyprime',
    logo: 'https://cdnstatic.nextias.com//Group-1741069899954.svg',
    websiteBaseUrl: process.env.REACT_APP_MADEEASY_HOST_URL,
    // Where a student is sent when an order cannot be processed on the page —
    // see the draft fallback in pages/order-details.
    supportUrl: `${process.env.REACT_APP_MADEEASY_HOST_URL}/contact-us`,
    thankYou: {
      successURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/payment-success`,
      failureURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/payment-failure`,
    },
    redirect: {
      successURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/prep/my-course`,
      failureURL: `${process.env.REACT_APP_MADEEASY_HOST_URL}/prep/home`,
    },
  },
};

export default organizationConfig;
